<template>
  <div class="main w-per100 minvh100 bg_w column a-center">
    <h1 class="seo-h1">{{ PageTitle || '佰信纸业 - 专业纸品制造与服务商' }}</h1>
    <MyNav :current="current" />

    <Banner />
    <About />
    <Product />
    <News />
    <ShowImgs />

    <MyFooter />
    
  </div>
</template>

<script>
import Banner from "@/components/index/banner.vue";
import About from "@/components/index/about.vue";
import Product from "@/components/index/product.vue";
import News from "@/components/index/news.vue";
import ShowImgs from "@/components/index/showImgs.vue";

import { mapGetters, mapActions } from 'vuex';
import { pageMetaInfo } from "@/utils/seo";
import {  } from "@/api/app";

export default {
  metaInfo() {
    return pageMetaInfo(this, '首页 - 热敏纸_不干胶标签纸_电脑打印纸厂家直销', { pageKey: 'Index' });
  },
  components:{
    Banner,
    About,
    Product,
    News,
    ShowImgs,
  },
  data() {
    return {
      current:0,
    }
  },
  computed: {
    ...mapGetters({
      PageTitle:'computedSeo1',
      PagekeyWords:'computedSeo2',
      PageDescription:'computedSeo3',
    })
  },
  mounted() {
    this.addJsonLd();
  },
  methods: {
    addJsonLd() {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.innerHTML = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        'name': '佰信纸业',
        'url': window.location.origin,
        'logo': this.$getAssetUrl('/favicon.ico'),
        'description': this.PageDescription || '专业纸品制造与服务商',
        'contactPoint': {
          '@type': 'ContactPoint',
          'telephone': this.$store.state.app.navInfo.tel || '',
          'contactType': 'customer service'
        }
      });
      document.head.appendChild(script);
    }
  }
}
</script>

<style scoped lang="scss">
.seo-h1 {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.main {
  
}
@media screen and (min-width: 750px) and (max-width: 1250px){
  .main {
    
  }
}
@media screen and (max-width: 750px){
  .main {
    
  }
}



</style>
